import TokenService from "./token.service";
import store from "@/store";

const setup = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
        config.headers["x-access-token"] = token; // for Node.js Express back-end
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      if (err.response && err.response.status === 401) {
        // Access Token was expired - attempt refresh if not already retried
        if (
          originalConfig &&
          !originalConfig._retry &&
          originalConfig.url !== "/auth/signin" &&
          originalConfig.url !== "/auth/login" &&
          originalConfig.url !== "/Auth/RefreshToken"
        ) {
          originalConfig._retry = true;

          try {
            const rs = await axiosInstance.post("/Auth/RefreshToken", {
              refreshToken: TokenService.getLocalRefreshToken(),
              IpAddress: ".",
            });

            store.dispatch("/Auth/RefreshToken", rs.data);

            originalConfig.headers.Authorization =
              "Bearer " + rs.data.accessToken;
            TokenService.updateLocalTokens(rs.data);
            return axiosInstance(originalConfig);
          } catch (_error) {
            TokenService.logOutUser();
            return Promise.reject(_error);
          }
        }

        // If 401 persists or refresh token fails / is not applicable, clear local user data
        TokenService.logOutUser();
      }

      return Promise.reject(err);
    }
  );
};

export default setup;
